module.exports = __webpack_public_path__ + "static/img/ic_arrow_up.379c257b.svg";